<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <load-more-articles
      :api-url="computedLoadApiUrl"
      :has-more="computedHasMoreToLoad"
      :initial-articles="recommendations"
      :load-more-cta-label="loadMoreCtaLabel"
      :loading-state-label="loadingStateLabel"
    >
      <template>
        <ul class="article-grid">
          <li
            v-for="(recommendation, $index) in recommendations"
            :key="$index"
          >
            <a
              v-tag:useractionevent="{
                cta_name: 'select',
                event: 'uaevent',
                event_detail: `${recommendation.position}::${recommendation.titlePlainText}`,
                event_name: 'article_click',
                ecommerce: undefined,
                category: recommendation.pageType,
                action: 'select',
                label: `${recommendation.position}::${recommendation.titlePlainText}`
              }"
              :href="recommendation.ctaLink"
              :title="recommendation.image.alt"
              class="article-card"
            >
              <div
                v-if="hasImage(recommendation)"
                class="image image--cover"
              >
                <img
                  v-srcset="recommendation.image.srcset"
                  :alt="recommendation.image.alt"
                  class="image__item"
                  :src="recommendation.image.src"
                >
              </div>
              <p class="article-card__surtitle">
                {{ recommendation.surtitle }}
              </p>
              <div class="article-card__title">
                <span v-html="recommendation.title" />
              </div>
              <p
                v-lineclamp="3"
                class="article-card__description"
                v-html="recommendation.description"
              />
            </a>
          </li>
        </ul>

        <div slot="loading">
          <div class="loading-icon" />
        </div>
      </template>
    </load-more-articles>
  </div>
</template>
<script>
  import LoadMoreArticles from '@Feature/LoadMoreArticles/code/Scripts/components/LoadMoreArticles/LoadMoreArticles.vue';
  import { srcset } from '@Foundation/directives/srcset/srcset';
  import { tag } from '@Foundation/analyticsHandler/directives/tag';
  import { lineclamp } from '@Foundation/directives/lineclamp/lineclamp';
  import { eventBus } from '@Foundation/eventbus/eventbus';
  import { take, drop } from 'lodash';

  export default {
    name: 'SfmcArticles',
    components: {
      LoadMoreArticles
    },
    directives: {
      srcset,
      tag,
      lineclamp
    },
    props: {
      componentData: {
        type: Object,
        required: true
      },
      recommendations: {
        type: Array,
        required: true
      },
      loadMoreApiUrl: {
        type: String,
        required: true,
        default: '/api/sfmc/load-more-sfmc-articles'
      },
      loadMoreCtaLabel: {
        type: String,
        required: false,
        default: 'Load More'
      },
      loadingStateLabel: {
        type: String,
        required: false,
        default: 'Loading more results'
      },
      loadMoreItems: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        articleIds: this.componentData.articleIds,
        loadMoreCurrentPage: 2,
        initialPosition: 0,
        dropArticles: this.recommendations.length
      };
    },
    computed: {
      computedLoadApiUrl() {
        const strArray = this.articleIds
          .map(p => `ids=${encodeURIComponent(p)}`)
          .join('&');
        return strArray
          ? `${this.loadMoreApiUrl}?${strArray}&initialPosition=${this.initialPosition}`
          : '';
      },
      computedHasMoreToLoad() {
        return this.articleIds.length !== 0;
      }
    },
    created() {
      this.updateArticleIds();
    },
    mounted() {
      eventBus.$on('load-more-articles', this.updateLoadMoreComponentData);
    },
    methods: {
      updateLoadMoreComponentData() {
        this.loadMoreCurrentPage++;
        this.updateArticleIds();
      },
      updateArticleIds() {
        if (!this.componentData.articleIds) {
          return;
        }

        const newArray = drop(this.componentData.articleIds, this.dropArticles);
        this.articleIds = take(newArray, this.loadMoreItems);
        this.dropArticles += this.articleIds.length;

        if (this.articleIds.length > 0) {
          this.initialPosition =
            this.componentData.articleIds.indexOf(this.articleIds[0]) + 1;
        }
      },
      hasImage(recommendation) {
        return !!(
          recommendation &&
          recommendation.image &&
          recommendation.image.src
        );
      }
    }
  };
</script>
